export class Cancel extends Error {
}
//# sourceMappingURL=Cancel.js.map